import type { NeoInsightLatest } from 'src/hooks/useNeoInsights'

/**
 * Magic Science morning insight — the framing shown on the Insights screen
 * (and as the seed paragraph on Neo's chat hero) when this demo set is
 * active. Mirrors what Nolan Springer would see at 8 AM on the 18th:
 * 5 Amazon FBA SKUs trending into the low-inventory-fee risk band, with
 * MS-HCL-001 as the worst — and the production-run recommendation that
 * keeps it clear for 47 days.
 */
export const magicScienceInsight: NeoInsightLatest = {
  id: 'demo-insight-magic-science-2026-05-18',
  type: 'DAILY',
  status: 'ACTIVE',
  userEmail: null,
  summaryText:
    '20 Amazon FBA SKUs reconciled this morning. **5 are tracking into the modeled low-inventory-fee band this week** — ~$2,400 of fee exposure on the table. **Pure HOCl Facial Mist 4oz (MS-HCL-001)** is the worst: 9 days of coverage, modeled to enter the band in 6 days. A 1,200-unit production run by Thursday May 21 ships ground 5/23, arrives Amazon 5/29, keeps the SKU clear for 47 days. MS-DIS-001 (7 days) and three others are forming the same pattern.',
  generatedAt: new Date().toISOString(),
  startDate: null,
  endDate: null,
  insights: {
    recommendations: [
      {
        id: 'ms-rec-mshcl001-production-run',
        title:
          'Pure HOCl Facial Mist 4oz (MS-HCL-001) — production run 1,200 units by Thu May 21',
        description:
          'MS-HCL-001 has 9 days of Amazon coverage left and is modeled to enter the low-inventory-fee band in 6 days. A production run of 1,200 units by Thursday May 21, shipping ground 5/23, arrives Amazon 5/29 and keeps the SKU clear of the band for 47 days.',
        priority: 'high',
        category: 'cost',
        dataPoints: [
          'On-hand: 1,140 units at Magic Science (Fishbowl), 340 at Amazon, 220 in-transit',
          'Demand-plan burn rate: 62 units/day',
          'Estimated Amazon low-inv-fee band entry: ~280 units (modeled, not from Amazon)',
          'Ground transit Minneapolis → Amazon: ~6 days',
        ],
        actionableSteps: [
          'Approve the production run for 1,200 units by Thu May 21',
          'Confirm raw-materials PO trigger with Sarah K. (raw-materials buyer)',
          'Schedule ship-out for Saturday 5/23 ground',
        ],
        estimatedImpact:
          'Clears the modeled band for 47 days. Surfaces before Wed 1pm SIOP — ~$580 of MS-HCL-001 fee exposure off the table.',
      },
    ],
  },
}
